import { gql } from '@anyx/common-graphql';

export const PRODUCT_TAGS_SELECT = gql(/* GraphQL */ `
  query ProductTagsSelect($filter: ProductTagsFilterInput) {
    tagsV2(filter: $filter)
  }
`);
